import { DateTime } from "luxon";

const DATE_TIME_FORMATS = {
    en: "ccc, LLLL d, yyyy 'at' hh:mm a",
    es: "ccc, d 'de' LLLL 'de' yyyy 'a las' hh:mm a",
    fr: "ccc d LLLL yyyy 'à' HH:mm",
};

export function formattedDateTime(
    utcDateTime,
    timezone = "America/Winnipeg",
    locale = "en",
    format
) {
    if (!utcDateTime) return "";

    return DateTime.fromISO(utcDateTime, { zone: "utc" })
        .setZone(timezone)
        .setLocale(locale)
        .toFormat(format || DATE_TIME_FORMATS[locale] || DATE_TIME_FORMATS.en);
}

export function inputFormatDateTime(
    utcDateTime,
    timezone = "America/Winnipeg"
) {
    if (!utcDateTime) return "";

    return DateTime.fromISO(utcDateTime, { zone: "utc" })
        .setZone(timezone)
        .toFormat("yyyy-MM-dd'T'HH:mm");
}

export function convertInputToUTC(
    datetimeLocalStr,
    timezone = "America/Winnipeg"
) {
    if (!datetimeLocalStr) return "";

    return DateTime.fromISO(datetimeLocalStr, { zone: timezone })
        .toUTC()
        .toISO();
}